import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';


@Pipe({
  name: 'flagUrl',
  standalone: true
})
export class FlagUrlPipe implements PipeTransform {

  transform(url: string): string {
    const base = environment.production ? 'src/' : '';
    return `${base}${url}`;
  }

}
